export const buy_icon = (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.5001 1.5L10.3501 7.65" stroke="#613917" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.75 4.62756V8.25006H13.3725" stroke="#613917" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V9.75" stroke="#613917" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

)

export const sell_icon = (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.75 8.2501L15.9 2.1001" stroke="#613917" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.4999 5.1V1.5H12.8999" stroke="#613917" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V9.75" stroke="#613917" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

)
